<template>
  <div class="allIssue">
    <!-- <zdy-nav title="全部问题" @back="back" :showClose="true" @close="close"></zdy-nav> -->
    <zdy-nav @back="back" :leftTitle="robotConfig.useType ? '全部问题' : '帮助与反馈'"></zdy-nav>
    <div class="issue-content">
      <div class="search-box" @click="toSearch">
        <img src="@/assets/searchIcon.svg" alt="">
        <span>搜索</span>
      </div>
      <Spin v-if="showLoading" fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>加载中，请稍后</div>
      </Spin>
      <cube-scroll style="height: calc(100vh - 96px);" :data="issueList" ref="cubeScroll" @pulling-down="onPullingDown"
        :options="options" :scrollEvents="['scroll']" @scroll="scrollEnd">
        <template v-for="(item, index) in issueList">
          <div class="issueBar" v-if="item"  :key="index">
            <div class="title" @click="showHide(item)">
              <div class="blue-line"></div>
              <span class="titleName">{{ item.typeName }}</span>
              <!-- <div class="more" :class="{ Rotation: item.isShow }"><i class="cubeic-select"></i></div> -->
              <img v-if="item.isShow" src="@/assets/jiantouTop.svg" alt="">
              <img v-if="!item.isShow" src="@/assets/jiantouBottom.svg" alt="">
            </div>
            <div class="container" v-if="item.isShow">
              <ul v-if="item.aiQuestionList && item.aiQuestionList.length">
                <!-- @click="toDetails(item)" -->
                <div v-for="(obj, i) in item.aiQuestionList" :key="i">
                  <li @touchstart="handleMouseEnter" @click="toDetails($event,obj)" >
                    <div>{{ obj.questionName }}</div>
                    <img src="@/assets/jiantouRight.svg" alt="">
                  </li>
                  <div v-if="item.aiQuestionList && item.aiQuestionList.length-1 !== i" class="borderBottom"></div>
                </div>
              </ul>
              <div class="noData" v-else>
                <img src="@/assets/notProblem.svg" alt="">
                暂无数据
              </div>
            </div>
          </div>
        </template>
      </cube-scroll>
      <div class="bottom-btn" v-if="!robotConfig.useType">
        <div class="btn-box" @click="btnClick(1)">
          <img src="@/assets/icon1.svg" alt="">
          异常反馈
        </div>
        <div class="line"></div>
        <div class="btn-box" @click="btnClick(2)">
          <img src="@/assets/icon2.svg" alt="">
          功能建议
        </div>
        <div class="line"></div>
        <div class="btn-box" @click="btnClick(3)">
          <img src="@/assets/icon3.svg" alt="">
          检查更新
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setStore, getStore, removeStore } from '@/utils/store'
export default {
  data() {
    return {
      issueList: [],
      panelList: [
        {
          name: '123',
          list: []
        }
      ],
      robotConfig: {},
      scrollRecord: null,
      showLoading: false,
      pullDownRefreshObj: {
        threshold: 90,
        stop: 40,
        txt: '刷新成功'
      },
    }
  },
  computed: {
    options() {
      return {
        useTransition: false,
        pullUpLoad: false, // 上拉加载 若要关闭可直接 pullUpLoad：false
        pullDownRefresh: this.pullDownRefreshObj, // 下拉刷新
      }
    },
  },
  created() {
    this.getAllIssueList();
    if (getStore({ name: 'robotConfig' })) {
      this.robotConfig = getStore({ name: 'robotConfig' })
    }
  },
  methods: {
    handleMouseEnter(e) {
      console.log(e);
      // if (e) {
        
      // }
      console.log(e.target.localName);
      if (e.target.localName != 'li') {
        e.target.parentElement.style.backgroundColor = '#F7F7F7'
        setTimeout(() => {
          e.target.parentElement.style.backgroundColor = ''
        }, 500);
      }else{
        e.target.style.backgroundColor = '#F7F7F7'
        setTimeout(() => {
          e.target.style.backgroundColor = ''
        }, 500);
      }
    },
    back() {
      if (this.robotConfig.useType) {
        this.$router.replace({ name: 'homPage' })
      } else {
        if (this.environment.isFengChao) {
          this.$cjc.closeWebView();
        }
      }
    },
    close() {
      this.$cjc.closeWebView();
    },
    // 下拉刷新并初始化
    onPullingDown() {
      removeStore({ name: 'scrollData', type: 'session' })
      removeStore({ name: 'showList', type: 'session' })
      this.getAllIssueList();
      if (getStore({ name: 'robotConfig' })) {
        this.robotConfig = getStore({ name: 'robotConfig' })
      }
    },
    toDetails(e,item) {
      if (item.answerType === 1) {
        this.$router.push({ name: 'answerPage', params: item });
      } else {
        window.open(item.answer);
      }
    },
    // 获取问题分类列表
    getAllIssueList() {
      this.showLoading = true
      this.$store.dispatch('questionType', {})
        .then((res) => {
          console.log(res,12390182);
          if (res.data.status === 1000) {
            const { result } = res.data;
            let arr = []
            if (getStore({ name: 'showList' })) {
              arr = getStore({ name: 'showList' })
            }
            result.map((item) => {
              if (arr.length) {
                let flag = false
                arr.map(val => {
                  if (item.questionType === val) {
                    flag = true
                  }
                })
                item.isShow = flag
                if (item.isShow) {
                  this.getTypeList(item, item.isShow)
                }
              } else {
                item.isShow = false;
              }
            });
            this.issueList = result
            setTimeout(() => {
              this.scrollMove()
              this.showLoading = false
            }, 100);
          } else {
            this.showMessage(res.data.msg)
            this.showLoading = false
          }
        }).catch(error => {
          this.showMessage(error)
          this.showLoading = false
        })
    },
    scrollMove() {
      const scrollData = getStore({ name: 'scrollData' })
      console.log('scrollData', scrollData)
      if (scrollData && scrollData.y !== 0) {
        this.$refs.cubeScroll.scrollTo(0, scrollData.y + 20, 0)
      }
    },
    async showHide(item) {
      console.log('showHide', item)
      if (!item.isShow) {
        await this.getTypeList(item, !item.isShow)
      }
      item.isShow = !item.isShow;
    },
    async getTypeList(item, type) {
      if (type) {
        const res = await this.$store.dispatch('getQuestionList', { questionType: item.questionType })
        if (res.data.status === 1000) {
          console.log(res);
          item.aiQuestionList = res.data.result
        } else {
          this.showMessage(res.data.msg)
        }
      }
    },
    // 前往搜索页
    toSearch() {
      this.$router.push({ path: '/searchPage' })
      console.log('搜索')
    },
    btnClick(num) {
      switch (num) {
        case 1:
          this.$router.push({
            name: 'feedbackPageIndex'
          })
          setStore({ name: 'fromType', content: { type: '1' }, type: 'session' })
          break;
        case 2:
          this.$router.push({
            name: 'feedbackPageIndex'
          })
          setStore({ name: 'fromType', content: { type: '2' }, type: 'session' })
          break;
        case 3:
          this.$cjc.apiCheckAppUpdate();
          break;
      }
    },
    // 显示提示信息弹窗
    showMessage(msg) {
      const toast = this.$createToast({
        txt: msg,
        time: 2000,
        type: 'error',
      })
      toast.show()
    },
    // 滚动结束位置
    scrollEnd(obj) {
      if (this.scrollRecord) {
        clearTimeout(this.scrollRecord)
        this.scrollRecord = null
      }
      console.log('scrollEnd', obj)
      this.scrollRecord = setTimeout(() => {
        setStore({ name: 'scrollData', content: obj, type: 'session' })
      }, 30)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'homPage') {
      let arr = []
      this.$data.issueList.map(item => {
        if (item.isShow) {
          arr.push(item.questionType)
        }
      })
      setStore({ name: 'showList', content: arr, type: 'session' })
    } else {
      removeStore({ name: 'showList', type: 'session' })
    }
    next()
  }
}
</script>

<style lang="scss">
.allIssue {
  .issue-content {
    background-color: #F0F2F3;
    margin-top: 44px;
    height: calc(100vh - 44px);
    overflow-y: auto;

    .search-box {
      width: calc(100vw - 24px);
      margin: 8px 12px;
      height: 36px;
      background: #FFFFFF;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #BDBDBD;

      img {
        margin-right: 4px;
      }
    }

    .issueBar {
      width: calc(100vw - 24px);
      margin-left: 12px;
      background: #ffffff;
      margin-bottom: 12px;
      border-radius: 10px;
      overflow: hidden;
      // padding: 12px 0 0px 12px;

      .title {
        // width: calc(100vw - 56px);
        font-size: 15px;
        font-weight: bold;
        color: #1A1A1A;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        margin-bottom: 0;
        padding: 12px;
          border-bottom: 1px solid #F1F2F3;
        .titleName {
          font-weight: bold;
          flex: 1;
          font-size: 15px;
        }
        .blue-line {
          margin-right: 5px;
          vertical-align: baseline;
          display: inline-block;
          width: 2px;
          height: 12px;
          border-radius: 10px;
          background-color: #3296FA;
        }

        .more {
          transition: transform .3s;
          font-size: 18px;
          float: right;
          color: #3296FA;
        }

        .Rotation {
          transform: rotate(180deg);
        }
      }

      .container {
        font-size: 14px;
        // padding: 0 12px;
        ul {
          // padding-top: 8px;
          // margin-top: 12px;
          li {
            // margin-bottom: 8px;
            padding: 12px 12px;
            font-size: 14px;
            color: #1A1A1A;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // padding: 0 12px;
            // padding-right: 16px;
            line-height: 20px;
            // border-bottom: 1px solid #F1F2F3;
            position: relative;
		        overflow: hidden;
            div {
              word-break: break-all;
              word-wrap: break-word;
            }

            img {
              margin-left: 8px;
            }
          }
          .borderBottom{
            height: 1px;background: #F2F2F2;
            margin: 0 12px;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }

        .noData {
          // padding-right: 16px;
          text-align: center;
          padding-top: 22px;
          padding-bottom: 22px;
          font-size: 14px;
          color: #A6A6A6;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .issueBar:last-child {
      margin-bottom: 90px;
    }

    .bottom-btn {
      position: fixed;
      bottom: 34px;
      left: 12px;
      z-index: 10;
      display: flex;
      justify-content: space-between;
      width: calc(100vw - 24px);
      border-radius: 24px;
      padding: 14px 16px;
      background-color: #FFFFFF;
      box-shadow: 0px 3px 8px 0px rgba(163, 163, 163, 0.25);

      .btn-box {
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #1A1A1A;

        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }

      .line {
        width: 1px;
        height: 16px;
        border: 1px solid #EFEFEF;
        margin: 2px 0;
      }
    }
  }
}
</style>